import React, { useState, useEffect } from 'react'
import { useLocation, Switch, Route, Redirect } from 'react-router-dom'
import AdminNavbarAlternative from 'components/argon/Navbars/AdminNavbarAlternative.js'
import Sidebar from 'components/argon/Sidebar/Sidebar.js'
import Box from '@material-ui/core/Box'
import DashboardIcon from '@material-ui/icons/Dashboard'
import StoreIcon from '@material-ui/icons/Store'
import TechnologyIcon from '@material-ui/icons/Memory'
import VerifiedIcon from '@material-ui/icons/CheckCircle'
import { makeStyles } from '@material-ui/core/styles'
import componentStyles from 'assets/theme/layouts/admin.js'
import eeLogo from 'resources/images/ee-logo.png'

import Providers from 'scenes/admin/Providers'
import Brands from 'scenes/admin/Brands'

const useStyles = makeStyles(componentStyles)

const Main = (props) => {
    const classes = useStyles()
    const location = useLocation()
    const [sidebarOpenResponsive, setSidebarOpenResponsive] = useState(false)

    console.log('admin router')

    useEffect(() => {
        document.documentElement.scrollTop = 0
        document.scrollingElement.scrollTop = 0
        // mainContent.current.scrollTop = 0
    }, [location])

    var routes = [
        {
            path: '/providers',
            name: 'Providers',
            icon: StoreIcon,
            iconColor: 'Success',
            component: Providers,
        },
        {
            path: '/brands',
            name: 'Brands',
            icon: TechnologyIcon,
            iconColor: 'Success',
            component: Brands
        }
    ]

    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.collapse) {
                return getRoutes(prop.views)
            } 
            else {
                return (
                    <Route
                        path={prop.path}
                        component={prop.component}
                        key={key}
                    />
                )
            }
        });
    };

    return (
        <>
            <Box display='flex'>
                <Sidebar
                    routes={routes}
                    openResponsive={sidebarOpenResponsive}
                    closeSidebarResponsive={() => setSidebarOpenResponsive(false)}
                    accountType='customer'
                    logo={{
                        innerLink: '/',
                        imgSrc: eeLogo,
                        imgAlt: '...',
                        className: 'sidebar-logo',
                    }}
                />
                <Box position='relative' flex='1' className={classes.mainContent}>
                    <AdminNavbarAlternative
                        openSidebarResponsive={() => setSidebarOpenResponsive(true)}
                        email={props.email}
                        companyName={'Admin'}
                        companyDetails={null}
                    />
                    
                    <Switch>
                        {getRoutes(routes)}
                        <Redirect from='*' to='/providers' />
                    </Switch>
                </Box>
            </Box>
        </>
    )
}

export default Main